<template>
  <div class="d-flex flex-column justify-center w-100">
    <h3 class="h4 mb-6 mb-md-10 text-center" v-if="modalStep !== 'success'">{{ $t('Заполните форму') }}</h3>

    <transition name="slide" mode="out-in">
      <form
        @submit.prevent="validateBeforeSubmitFirst()"
        :data-vv-scope="formScopeFirst"
        key="step 1"
        class="step_one col-12 px-0 d-flex flex-column w-100 align-center"
        v-if="modalStep === 1"
      >
        <label class="mb-6 form-label fontM">{{$t('НОМЕР ТЕЛЕФОНА')}}</label>
        <!-- <div class="posr"> -->
        <input
          autofocus
          type="tel"
          name="phone"
          class="form-input mb-9 mb-md-12 catch-phone"
          :placeholder="$t('Телефон')"
          v-model="phone"
          autocomplete="off"
          ref="inputPhoneRef"
          key="phone"
          @keypress.enter="$emit('submit')"
        >
        <!-- <div v-show="!validPhone" class="error-tooltip" ref="errorRef">
            <div class="error-inner p-6">
              <p>{{$t('Номер телефона должен содержать только цифры и быть в пределах от 6 до 15 символов')}}</p>
            </div>
        </div>-->
        <!-- </div> -->
        <!-- :class="{'input': true, 'is-danger': errors.has('phone', formEditContacts2), 'number-error': input.phone_isvalid === false, 'number-valid': input.phone_isvalid === true }" -->
        <!-- TODO: сделать фокус при открытии -->
        <!-- <vue-tel-input
          id="phone"
          name="phone"
          class="form-input mb-12"
          :data-vv-as="$t('Телефон')"
          @onInput="onInputPhone"
          :preferredCountries="['ru', 'kz', 'ua']"
          v-model="phone"
          type="number"
          placeholder
          ref="inputPhoneref"
          autocomplete="off"
          autofocus
        ></vue-tel-input>-->

        <!-- <p
            v-show="errors.has('phone', formEditContacts2)"
            class="alert-danger"
        >{{ errors.first('phone', formEditContacts2) }}</p>-->
        <div class="info-block">
          <p class="text-center">
            {{$t('Отправляя свои данные, вы соглашаетесь с')}}
            <a
              href="/privacy"
              rel="nofollow"
              target="_blank"
              class="link-main link-main--border"
            >{{$t('политикой конфиденциальности') }}</a>
          </p>
        </div>

        <!-- <transition name="fade" mode="out-in"> -->
        <!-- TODO: сделать класс с прозрачностью -->
        <span
          class="uppercase valid_text fontM mb-6"
          v-if="validPhone"
          key="valid"
        >{{$t('готово к отправке')}}</span>
        <span
          class="uppercase valid_text fontM mb-6"
          v-else
          key="invalid"
        >{{$t('введите номер телефона')}}</span>
        <!-- </transition> -->

        <v-btn
          color="green"
          big
          :disabled="!validPhone"
          width_btn="100%"
          height_btn="4.8rem"
          class="fz22 m-auto button-next"
          type="button"
          @click="getClick"
        >{{$t('Далее')}}</v-btn>
      </form>

      <form
        @submit.prevent="validateBeforeSubmitSecond(formScopeSecond)"
        :data-vv-scope="formScopeSecond"
        key="step 2.1"
        class="step_two col-12 px-0 d-flex w-100 flex-column align-center"
        v-if="modalStep === 2"
      >
        <label for="email" class="mb-6 form-label fontM uppercase">{{$t('Электронная почта')}}</label>
        <bim-input
          type="email"
          id="email"
          name="email"
          dadataType="email"
          class="form-input mb-10 catch-email"
          placeholder="E-mail"
          v-validate="'required|email'"
          v-model="email"
          key="email1"
        />

        <label class="mb-6 form-label fontM uppercase">{{$t('Дополнительные данные')}}</label>
        <input
          type="text"
          id="name"
          name="name"
          class="form-input mb-6"
          :placeholder="$t('Имя')"
          v-model="name"
          key="name1"
        >
        <input
          type="text"
          id="inn"
          name="inn"
          class="form-input mb-9"
          :placeholder="$t('ИНН')"
          v-model="inn"
          key="inn"
          @keypress.enter="$emit('submit')"
        >

        <span class="uppercase valid_text fontM mb-6" key="valid">{{$t('готово к отправке')}}</span>

        <v-btn
          :disabled="BtnDisabledSecond"
          color="green"
          big
          width_btn="100%"
          height_btn="4.8rem"
          class="fz22 m-auto"
          @click="!name || !email || !inn ? modalStep = 'success' : null"
        >{{$t('Отправить заявку')}}</v-btn>
      </form>
      <form
        @submit.prevent="validateBeforeSubmitThird(formScopeThird)"
        :data-vv-scope="formScopeThird"
        key="step 2.2"
        class="step_two col-12 px-0 w-100 d-flex flex-column align-center"
        v-if="modalStep === 3"
      >
        <bimInput
          type="email"
          id="email1"
          name="email1"
          dadataType="email"
          data-vv-as='"Электронная почта"'
          class="form-input mb-6 catch-email"
          :placeholder="$t('Электронная почта')"
          v-model="email"
          v-validate="'required|email'"
          key="email2"
          @blur="emailTouched = true"
          :valid="emailTouched && errors.has('email1', formScopeThird) ? false : null"
        />
        <span class="form-error-info" v-if="emailTouched && errors.has('email1', formScopeThird)">{{errors.items[0].msg}}</span>

        <input
          type="text"
          id="name1"
          name="name1"
          class="form-input mb-51"
          :placeholder="$t('Имя')"
          v-model="name"
          key="name2"
          @keypress.enter="$emit('submit')"
        >

        <div class="info-block-two mb-11">
          <p
            class="text-center"
          >{{$t('Все данные шифруются и передаются напрямую нашим специалистам')}}</p>
        </div>

        <span class="uppercase valid_text fontM mb-6" key="valid">{{$t('готово к отправке')}}</span>

        <v-btn
          :disabled="BtnDisabledThird"
          color="green"
          big
          width_btn="100%"
          height_btn="4.8rem"
          class="fz22 m-auto"
        >{{$t('Отправить заявку')}}</v-btn>
        <!-- //TODO: сделать функцию для success -->
      </form>

      <div class="success-send-request pt-10 pb-9 px-0 text-center" v-if="modalStep === 'success'">
        <img src="/dist/assets/front_white/img/icons/check-round.svg" alt="success" class="mb-6">
        <h4 class="h4 active-color mb-6">Заявка отправлена</h4>
        <p class="mb-11">
          <span class="fw-bold">Спасибо за заявку!</span> <br>В ближайшее время мы вам перезвоним.
        </p>

        <v-btn color="green" @click="closeModal()" big class="mx-auto">Принято</v-btn>
      </div>
    </transition>
  </div>
</template>

<script>
import bimInput from '@bimlib/components/bimInput'
export default {
  components: {
    bimInput
  },
  props: {
    form_type: {
      type: Number,
      default: null,
      required: true
    },
    close: Boolean,
    user_info: {
      type: Object,
      default: () => ({
        isLogin: false
      })
    },
    /**
     * Посылается при отправке запроса
     */
    additionalInfo: String,
  },
  data() {
    return {
      phone: "",
      email: "",
      emailTouched: false,
      name: "",
      inn: "",
      validPhone: false,
      phone_valid: false,
      formScopeFirst: "sendRequest",
      formScopeSecond: "sendRequest1",
      formScopeThird: "sendRequest2",
      modalStep: 1,
      UUID: "",
      BtnDisabledSecond: false,
      BtnDisabledThird: false,
      timeout: null,
      timeout2: null,
      ya_login: "",
      utm: "",
      formCatcher: {
        location: '',
        name: '',
        phone: '',
        email: '',
        inn: '',
        date: '',
        id: '',
      },
    };
  },
  created() {
    window.addEventListener('beforeunload', ( ) => {
      if (this.timeout !== null) {
        this.sendFormCatcher()
      }
      if (this.timeout2 !== null) {
        this.sendUserData()
      }
      this.cleanLocalStorageFromForm()
    })
    this.timeout = setTimeout(this.sendFormCatcher, 30000);
    this.timeout2 = setTimeout(this.sendUserData, 60000)

    const path = window.location.pathname.split("/")[1];
    this.formCatcher.location = path.length ? path : "main_page";

    this.formCatcher.id = Date.now();

    var today = new Date();
    var month = today.getMonth() + 1;
    this.formCatcher.date = today.getUTCHours() + 3 + ":" + today.getUTCMinutes() + ":" + today.getUTCSeconds() + ' ' + today.getDate() + ' ' + month + ' ' + today.getFullYear();
  },
  mounted() {
    this.$refs.inputPhoneRef.focus();
    this.UUID = localStorage.getItem('UUID')
    this.closeModalStatic();
    this.ya_login = this.getCookie('yandex_login') || "";
    this.utm = window.location.href.indexOf("utm_source") > -1 ? new URL(window.location.href).search : '' || "";
    window.location.href.indexOf("utm_source") > -1 ? localStorage.setItem("__feedback_utm", this.utm) : '' || "";
  },
  watch: {
    phone(val, oldValue) {
      this.$store.dispatch("validationPhone", val);
      this.validPhone = this.$store.getters.isValid;
      if(val.length >= this.formCatcher.phone.length) {
        this.formCatcher.phone = val
      }
      localStorage.setItem("__feedback_phone", val)
    },
    email(val) {
      if(val.length >= this.formCatcher.email.length) {
        this.formCatcher.email = val
      }
      localStorage.setItem("__feedback_email", val)
    },
    name(val) {
      if(val.length >= this.formCatcher.name.length) {
        this.formCatcher.name = val
      }
      localStorage.setItem("__feedback_name", val)
    },
    inn(val) {
      if(val.length >= this.formCatcher.inn.length) {
        this.formCatcher.inn = val
      }
      localStorage.setItem("__feedback_inn", val)
    },
    input_link_video: function(value) {
      let param = value.match(
        /^.*(youtu.be\/|v\/|e\/|u\/\w+\/|embed\/|v=)([^#\&\?]*).*/
      );
      this.input.link_video = "https://www.youtube.com/embed/" + param[2];
    },
    close() {
      this.modalStep = 1;
      this.phone = "";
      this.email = "";
      this.name = "";
      this.inn = "";
    }
  },
  methods: {
    getCookie(name) {
      let matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
      ));
      return matches ? decodeURIComponent(matches[1]) : undefined;
    },
    cleanLocalStorageFromForm() {
      localStorage.removeItem("__feedback_phone")
      localStorage.removeItem("__feedback_email")
      localStorage.removeItem("__feedback_name")
      localStorage.removeItem("__feedback_inn")
      localStorage.removeItem("__feedback_utm")
    },
    sendFormCatcher() {
      const form = {
        phone: "",
        email: "",
        name: "",
        inn: "",
      }
      for (let i in form) {
        form[i] = localStorage.getItem("__feedback_" + i) || ""
      }

      const data = new FormData();
      data.append('key', this.UUID);
      data.append('lead', JSON.stringify({...this.formCatcher, ...form}));

      axios.post('/?a=formCatcher', data)
    },
    sendUserData() {
      const data = new FormData();
      const form = {
        phone: localStorage.getItem("__feedback_phone") || "",
        first_name: localStorage.getItem("__feedback_name") || "",
        inn: localStorage.getItem("__feedback_inn") || "",
        email: localStorage.getItem("__feedback_email") || "",
        ya_login: this.ya_login,
        utm: localStorage.getItem("__feedback_utm") || "",
      }
      if (form.phone.length < 6) return
      if (form.first_name || form.inn || form.email) {
        for (let i in form) {
          data.append(i, form[i])
        }
        data.append("type", "manufacturer");
        data.append("agree", "on");
        data.append("UUID", this.UUID);
        axios.post("/?m=Statics&a=form_request", data)
      }
    },
    closeModal() {
      clearTimeout(this.timeout)
      clearTimeout(this.timeout2)
      this.sendUserData()
      this.sendFormCatcher()
      this.cleanLocalStorageFromForm()

      const modalOverlay = document.querySelectorAll(".modalOverlay")[0],
        modalOverlayLight = document.querySelectorAll(".modalOverlay_light")[0];
      try {
        document.getElementById("sendPhone").classList.remove("open");
        document.getElementById("sendPhone").classList.remove("open-reg");
        document.getElementById("sendPhone").classList.add("closed");
        modalOverlay.classList.remove("open-overlay");
        modalOverlay.classList.add("closed-overlay");
        modalOverlayLight.classList.remove("open-overlay");
        modalOverlayLight.classList.add("closed-overlay");
        document.body.classList.remove("open-modal--overflow");
      } catch (err) {
        console.error(err);
      }
      this.$emit("close");
      this.modalStep = 1;
      this.phone = "";
      this.email = "";
      this.name = "";
      this.inn = "";
    },
    closeModalStatic() {

      let btnClose = document.getElementById("close-button-icon"),
        modalTariff = document.getElementById("modal-tariff"),
        btnCloseTariff = document.getElementById("btn-close"),
        overlay = document.querySelector(".modalOverlay_light");
      document.body.addEventListener("click", e => {

        if (e.target === btnClose || e.target === overlay) {
          this.closeModal();
        } else if (e.target === modalTariff || e.target === btnCloseTariff) {
          // TODO: крестик не срабатывает!!!
          this.modalStep = 1;
          this.phone = "";
          this.email = "";
          this.name = "";
          this.inn = "";
        }
      });
    },
    validateBeforeSubmitFirst() {
      if (this.validPhone) {
        return
      } else {
        console.error("error");
      }
    },
    validateBeforeSubmitSecond(scope) {
      this.BtnDisabledSecond = true
      this.$validator
        .validateAll(scope)
        .then(result => {
          if (result) {
            clearTimeout(this.timeout2)
            clearTimeout(this.timeout)
            this.sendFormCatcher()
            this.cleanLocalStorageFromForm()
            const data = new FormData();
            if (!_.isEmpty(this.phone)) {
              data.append("phone", this.phone);
            }
            if (!_.isEmpty(this.name)) {
              data.append("first_name", this.name);
            }
            if (!_.isEmpty(this.inn)) {
              data.append("inn", this.inn);
            }
            if (this.additionalInfo) {
              data.append('servicesArray', JSON.stringify([{ info: this.additionalInfo }]))
            }
            data.append("email", this.email);
            data.append("type", "manufacturer");
            data.append("agree", "on");
            data.append("UUID", this.UUID);
            data.append("ya_login", this.ya_login);
            data.append("utm", this.utm);

            axios
              .post("/?m=Statics&a=form_request", data)
              .then(response => {
                if (response.data.success === true) {
                  if (localStorage.getItem('dev_mode')) {
                  } else {
                    try {
                      const isMan = this.user_info.account_type === "manufacturer" || ""
                      ym(40131035, "reachGoal", "PROFILE_SIGNUP");
                      ym(40131035, 'userParams', {
                        UserID: this.user_info.id,
                        manufacturer: isMan,
                        designer: !isMan,
                        UserPhone: this.user_info.phone || "",
                        UserMail: this.user_info.email || "",
                        UserCompany: this.user_info.company || "",
                      });
                    } catch (e) {
                      console.error(e);
                    }
                    try {
                      dataLayer.push({
                        event: "EVENT2GA",
                        eventCategory: "PROFILE",
                        eventAction: "SIGNUP",
                        eventLabel: "",
                        eventValue: ""
                      });
                    } catch (e) {
                      console.error(e);
                    }
                    try {
                      fbq("trackCustom", "PROFILE_SIGNUP");
                    } catch (e) {
                      console.error(e);
                    }
                    try {
                      fbq('track', 'Lead');
                    } catch (e) {
                      console.error(e)
                    }
                  }
                }
                this.modalStep = "success";
              }).then(response => {
              this.BtnDisabledThird = false
            })
              .catch(function(error) {
                console.error(error);
                this.BtnDisabledSecond = false
              });
          } else {
            this.BtnDisabledSecond = false
          }
        })
        .catch(e => {
          console.error(e);
          this.BtnDisabledSecond = false
        });
    },
    validateBeforeSubmitThird(scope) {
      this.BtnDisabledThird = true;
      this.$validator
        .validateAll(scope)
        .then(result => {
          if (result || !scope) {
            clearTimeout(this.timeout2)
            clearTimeout(this.timeout)
            this.sendFormCatcher()
            this.cleanLocalStorageFromForm()
            this.modalStep = 'success'

            const data = new FormData();
            if (!_.isEmpty(this.phone)) {
              data.append("phone", this.phone);
            }
            if (!_.isEmpty(this.name)) {
              data.append("first_name", this.name);
            }
            data.append("email", this.email);
            data.append("type", "manufacturer");
            data.append("agree", "on");
            data.append("UUID", this.UUID);
            data.append("ya_login", this.ya_login);
            data.append("utm", this.utm);
            if (this.additionalInfo) {
              data.append('servicesArray', JSON.stringify([{ name: this.additionalInfo }]))
            }
            // Оставил email пошлем метрику в любом случае
            try {
              ym(40131035, "reachGoal", "EMAIL_FILLING");
            } catch (e) {
              console.error(e);
            }
            try {
              dataLayer.push({
                event: "EVENT2GA",
                eventCategory: "EMAIL",
                eventAction: "FILLING",
                eventLabel: "",
                eventValue: "",
                // phone: this.email
              });
            } catch (e) {
              console.error(e);
            }
            try {
              fbq("trackCustom", "EMAIL_FILLING");
            } catch (e) {
              console.error(e);
            }
            try {
              fbq('track', 'Lead');
            } catch (e) {
              console.error(e);
            }
            // попробуем зарегистрировать.. если получится, то пошлем еще метрику
            axios
              .post("/?m=Statics&a=form_request", data)
              .then(response => {
                if (response.data.success === true) {
                  if(!localStorage.getItem('dev_mode')) {
                    try {
                      const isMan = this.user_info.account_type === "manufacturer" || ""
                      ym(40131035, "reachGoal", "PROFILE_SIGNUP");
                      ym(40131035, 'userParams', {
                        UserID: this.user_info.id,
                        manufacturer: isMan,
                        designer: !isMan,
                        UserPhone: this.user_info.phone || "",
                        UserMail: this.user_info.email || "",
                        UserCompany: this.user_info.company || "",
                      })
                    } catch (e) {

                    }
                    try {
                      dataLayer.push({
                        event: "EVENT2GA",
                        eventCategory: "PROFILE",
                        eventAction: "SIGNUP",
                        eventLabel: "",
                        eventValue: ""
                      });
                    } catch (e) {

                    }
                    try {
                      fbq("trackCustom", "PROFILE_SIGNUP");
                    } catch (e) {

                    }
                  }
                }
                this.modalStep = "success";
              }).then(response =>{
              this.BtnDisabledThird = false
            })
              .catch(function(error) {
                console.error(error);
                this.BtnDisabledThird = false
              });
          } else {
            this.BtnDisabledThird = false
          }
        })
        .catch(e => {
          this.BtnDisabledThird = false
          console.error(e);
        });
    },
    getClick() {
      if (this.form_type === 1) {
        this.modalStep = 2;
      }
      else {
        const { isLogin, email, first_name, last_name } = this.user_info
        if (isLogin) {
          this.validateBeforeSubmitThird()
          localStorage.setItem("__feedback_email", email)
          localStorage.setItem("__feedback_name", first_name + " " + last_name)
          this.sendUserData()
          this.sendFormCatcher()
          this.cleanLocalStorageFromForm()
          this.modalStep = "success"
        }
        else {
          this.modalStep = 3;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/color";
@import "./src/front_white/sass/components/mixins";
@import './src/front_white/sass/components/settings';

.button-next {
  @media (min-width: $breakpoint-xs) and (max-width: width-max($breakpoint-md)) {
			height: 2.8rem !important;
		}
}

.form-error-info {
  padding-bottom: 10px;
  font-size: 12px;
  color: $error;
}

.form-label {
  font-size: 1.0667rem;
  line-height: 1.44;
  letter-spacing: 0.0333rem;
  @include font-main(1.0667rem, 600, 1.44, 0.0333rem, $text-main);
}

.form-input {
  width: 100%;
  height: 4.8rem;
  @include font-main(1.5rem, normal, 1.02, 0.0067rem, $text-main);
  text-align: center;
  border: solid 0.1rem #d8d8d8;
  border-radius: 0.3333rem;
  @media (min-width: $breakpoint-xs) and (max-width: width-max($breakpoint-md)) {
    height: 2.8rem;
  }
  ::v-deep {
    .bim-input {
      text-align: center;
      &, input {
        width: 100%;
        height: 100%;
      }
      label {
        font-size: 1.5rem;
        font-weight: normal;
        line-height: 1.02;
        letter-spacing: 0.0067rem;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        white-space: nowrap;
      }
      input {
        border: none;
        font-size: 1.5rem;
      }
      &.focus label, &.notEmpty label {
        display: none
      }
    }
  }
  input {
    color: $text-main;
    text-align: center;
  }
  &:hover {
    border-color: #afafaf;
  }
  &:focus {
    border-color: $active;
  }
  &:focus-within {
    box-shadow: none;
    border-color: unset;
    border: solid 0.1rem $active;
  }
}
::-webkit-input-placeholder {
  color: #b2b2b2;
}
::-moz-placeholder {
  color: #b2b2b2;
} /* Firefox 19+ */
:-moz-placeholder {
  color: #b2b2b2;
} /* Firefox 18- */
:-ms-input-placeholder {
  color: #b2b2b2;
}

// :focus::-webkit-input-placeholder {
//   opacity: 0;
// }
// :focus::-moz-placeholder {
//   opacity: 0;
// }
// :focus:-moz-placeholder {
//   opacity: 0;
// }
// :focus:-ms-input-placeholder {
//   opacity: 0;
// }

.info-block {
  padding-top: 4.5333rem;
  margin-bottom: 4.6667rem;
  background: url("/dist/assets/front_white/img/svg/lock-info.svg") no-repeat 50% 0;
  background-size: 3rem 3.2rem;
  @media (min-width: $breakpoint-xs) and (max-width: width-max($breakpoint-md)) {
		margin-bottom: 2.6667rem;
	}
}
.info-block-two {
  width: 15.8rem;
}
.valid_text {
  @include font-main(0.9667rem, 600, 1.77, 0.1rem, $active);
  text-align: center;
  opacity: 1;
}
.mb-51 {
  margin-bottom: 3.4rem;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-enter {
  transform: translateX(25rem);
  opacity: 0;
}
.slide-enter-to,
.slide-leave {
  transform: translateX(0);
}
.slide-leave-to {
  transform: translateX(-25rem);
  opacity: 0;
}
.error-tooltip {
  bottom: 85%;
}
.link-main--border {
  border-bottom: 1px dashed $active
}
</style>
